module.exports = __webpack_public_path__ + "img/playstore-w.ea31b27f.svg";